import * as types from '../../constants/backoffice/ipConstants';

export const allowedIpListRequest = (page, pageLength) => ({
  type: types.ALLOWED_IP_LIST_REQUEST,
  page,
  pageLength
});

export const setAllowedIpList = (allowedIpList) => ({
  type: types.SET_ALLOWED_IP_LIST,
  allowedIpList
});

export const allowedIpCreate = (beginIpAddr, endIpAddr, description, page, pageLength) => ({
  type: types.ALLOWED_IP_CREATE,
  beginIpAddr,
  endIpAddr,
  description,
  page,
  pageLength
});

export const allowedIpRemove = (ipBlockNoArray, page, pageLength) => ({
  type: types.ALLOWED_IP_REMOVE,
  ipBlockNoArray,
  page,
  pageLength
});

export const setTotalCount = totalCount => ({
  type: types.SET_TOTAL_COUNT,
  totalCount
});

export const setIpPage = page => ({
  type: types.SET_IP_PAGE,
  page
});
